import { createContext, useContext } from 'react';

import { TimestampFormat } from '@components/primitives/Timestamp';

export type TimelineEventVariant =
  | 'info'
  | 'success'
  | 'warning'
  | 'error'
  | 'pending';

export interface TimelineContextValue {
  timestampFormat?: TimestampFormat;
}

export const TimelineContext = createContext<TimelineContextValue>({});

export interface TimelineEventContextValue {
  variant: TimelineEventVariant;
}

export const TimelineEventContext =
  createContext<TimelineEventContextValue | null>(null);

/**
 * Lets an event's parts read its variant without it being threaded down, so a
 * pending event can swap its icon for a spinner and drop its timestamp.
 */
export function useTimelineEventContext(): TimelineEventContextValue {
  const context = useContext(TimelineEventContext);

  if (!context) {
    throw new Error(
      'Timeline event parts must be rendered inside a <Timeline.Event>.'
    );
  }

  return context;
}
